import React, { useEffect, useState } from "react";
import GlobalStyles from "../../global/GlobalStyles";
import api from "../../global/api";
import { FaCheckCircle, FaClock, FaTruck } from "react-icons/fa";
import { Link } from "react-router-dom";
import SmallLoader from "../loaders/SmallLoader";

const RecentShipments = () => {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRecentShipments = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/recent-shipments");
      setShipments(data);
    } catch (error) {
      console.error("Error fetching shipments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecentShipments();
  }, []);

  const getStatusIcon = (status) => {
    switch (status) {
      case "delivered":
        return <FaCheckCircle className="text-green-500" />;
      case "in_transit":
        return <FaTruck className="text-blue-500" />;
      default:
        return <FaClock className="text-yellow-500" />;
    }
  };

  return (
    <div className={GlobalStyles.sectionWrap}>
      <h2 className={`${GlobalStyles.sectionHeader} mb-4`}>Recent Shipments</h2>

      {loading ? (
        <div className="w-full flex justify-center">
          <SmallLoader />
        </div>
      ) : shipments.length === 0 ? (
        <div className="w-full flex flex-col gap-3">
          <p className="text-xs text-primary">
            No shipments have been created yet.
          </p>
          <Link
            to="/admin/dashboard/manage-shipping"
            className={`${GlobalStyles.buttonFullAlt}`}
          >
            View All Shipments
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {shipments.map((shipment) => (
            <Link
              to={`/admin/dashboard/manage-shipping/${shipment.tracking_id}`}
              key={shipment.id}
              className={`${GlobalStyles.listItem} flex items-center justify-between p-3`}
            >
              <div className="flex items-center gap-3">
                {getStatusIcon(shipment.status)}
                <div>
                  <p className={GlobalStyles.textSecondary}>
                    {shipment.tracking_id}
                  </p>
                  <p className={`${GlobalStyles.textSecondary} text-xs`}>
                    {shipment.origin} → {shipment.destination}
                  </p>
                </div>
              </div>
              <span className="text-sm capitalize text-primary">
                {shipment.status}
              </span>
            </Link>
          ))}

          <div className="mt-4 text-center">
            <Link
              to="/admin/dashboard/manage-shipping"
              className={`${GlobalStyles.buttonFullAlt}`}
            >
              View All Shipments
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentShipments;
